<script>
  import { onMount, createEventDispatcher } from 'svelte';
  export let label = '안내';
  export let closable = true;
  const dispatch = createEventDispatcher();
  let panel;
  function close() { if (closable) dispatch('close'); }
  function keydown(event) {
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      const nodes = [...panel.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), select, textarea, [tabindex="0"]')];
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }
  onMount(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden'; panel.focus();
    return () => { document.body.style.overflow = overflow; previous?.focus(); };
  });
</script>
<svelte:window on:keydown={keydown} />
<div class="backdrop">
  <section bind:this={panel} role="dialog" aria-modal="true" aria-label={label} tabindex="-1">
    {#if closable}<button type="button" class="close" aria-label="닫기" on:click={close}>×</button>{/if}
    <slot />
  </section>
</div>
<style>
  .backdrop { position: fixed; inset: 0; z-index: 3000; display: grid; place-items: center; background: #0008; padding: 20px; }
  section { position: relative; width: min(920px, 100%); max-height: 90dvh; overflow-y: auto; padding: 24px; background: #fff; color: #333; border-radius: 20px; box-shadow: 0 12px 50px #0003; }
  :global(.dark) section { background: #242424; color: #f5f5f5; }
  .close { position: sticky; top: 0; display: block; margin-left: auto; border: 0; border-radius: 50%; background: #8882; color: inherit; font-size: 24px; width: 36px; height: 36px; cursor: pointer; z-index: 1; }
</style>
